import { ServiceData } from '../service';
import db from '../index';
import { entityServiceFactory } from '../entityServiceFactory';

export interface VisibleFieldsServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<VisibleFieldsServiceData>(
    db,
    'visibleFieldsService'
  );

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
